import consts from "consts"
import { GET_STRAPI_LANDING_CONFIG_PENDING, GET_STRAPI_LANDING_CONFIG_SUCCESS, SET_404_ERROR } from "consts/actions"

export function getStrapiData() {
  return (dispatch, getState) => {
    const query = getState().router.location.pathname.replace("/s/", "")
    const search = getState().router.location.search
    const base = getState().appSettings.host

    return dispatch({
      accessTokenRequired: false,
      request: {
        base,
        url: consts.endpoints.strapi.landing.APIPath + "/" + query + search,
        method: "GET",
      },
      onStart: () => {
        return {
          type: GET_STRAPI_LANDING_CONFIG_PENDING,
        }
      },
      onSuccess: (payload, meta, dispatch) => {
        return dispatch({
          type: GET_STRAPI_LANDING_CONFIG_SUCCESS,
          payload: payload[0],
        })
      },
      onError: () => {
        return {
          type: SET_404_ERROR,
        }
      },
    })
  }
}
